import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Chapter, Reveal } from "@/components/Chapter";
import { useContent } from "@/content";

const Item = ({ q, a, open, onToggle, i }) => (
  <div className={`rounded-2xl border transition-colors duration-500 ${open ? "border-amber-400/60 bg-white shadow-lg shadow-slate-900/5" : "border-slate-200 bg-white/70 hover:border-slate-300"}`} data-testid={`faq-item-${i}`}>
    <button onClick={onToggle} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left" data-testid={`faq-toggle-${i}`} aria-expanded={open}>
      <span className="text-base font-semibold text-[#0B1528]">{q}</span>
      <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.3 }} className={`shrink-0 rounded-full border p-1.5 ${open ? "border-amber-400 bg-amber-400 text-[#0B1528]" : "border-slate-300 text-slate-500"}`}>
        <Plus className="h-4 w-4" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
          data-testid={`faq-answer-${i}`}
        >
          <p className="px-6 pb-6 text-sm sm:text-base text-slate-500 leading-relaxed">{a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const FAQ = () => {
  const { FAQ: ITEMS } = useContent();
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative max-w-7xl mx-auto px-4 sm:px-8 py-24 md:py-32" data-testid="faq-section">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20 items-start">
        <div className="lg:sticky lg:top-28">
          <Chapter id="07" name="FAQ" title="Questions we hear most." sub="Anything else? Send us a message — our team replies within one working day." />
        </div>
        <Reveal className="space-y-3">
          {ITEMS.map((f, i) => (
            <Item key={f.q} i={i} {...f} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};
